import React from 'react';
import PropTypes from 'prop-types';
import { UniversalLink } from '@plone/volto/components';

/**
 * Passo a passo — etapas numeradas no molde dos folders da AgSUS: números
 * grandes nas cores da faixa da marca (amarelo, vermelho, verde, azul), cada
 * um ligado ao seguinte por uma linha na sua cor, e cada passo num cartão
 * branco. Lado a lado no computador (até 5 passos) ou em coluna; no celular,
 * sempre em coluna. A lista é um <ol>: o leitor de tela já anuncia a ordem, e
 * o número desenhado fica só para a vista.
 */

export const DISPOSICOES = ['horizontal', 'vertical'];
export const FUNDOS = ['creme', 'azul', 'branco'];
// Acima disto, lado a lado espreme os cartões: fica em coluna.
export const MAX_LADO_A_LADO = 5;

const escolha = (valor, opcoes, padrao) =>
  opcoes.includes(valor) ? valor : padrao;

const PassosView = ({ data = {}, vazio = null }) => {
  const passos = (data.passos || []).filter(
    (p) => (p?.texto || '').trim() || (p?.titulo || '').trim(),
  );
  if (!passos.length) return vazio;

  const fundo = escolha(data.fundo, FUNDOS, 'creme');
  const pedida = escolha(data.disposicao, DISPOSICOES, 'horizontal');
  const disposicao = passos.length > MAX_LADO_A_LADO ? 'vertical' : pedida;

  const lista = (
    <ol className="ag-passos__lista" style={{ '--n': passos.length }}>
      {passos.map((p, i) => (
        <li key={p['@id'] || i} className="ag-passos__passo">
          <span className="ag-passos__numero" aria-hidden="true">
            {i + 1}
          </span>
          <div className="ag-passos__cartao">
            {(p.titulo || '').trim() && (
              <strong className="ag-passos__titulo">{p.titulo.trim()}</strong>
            )}
            {(p.texto || '').trim() && (
              <p className="ag-passos__texto">{p.texto.trim()}</p>
            )}
            {(p.link || '').trim() && (
              <UniversalLink href={p.link.trim()} className="ag-passos__link">
                {(p.rotuloLink || '').trim() || 'Saiba mais'}{' '}
                <span aria-hidden="true">→</span>
              </UniversalLink>
            )}
          </div>
        </li>
      ))}
    </ol>
  );

  return (
    <div className={`ag-passos ag-passos--${disposicao} ag-passos--${fundo}`}>
      {fundo === 'branco' ? (
        lista
      ) : (
        <div className="ag-passos__inner">{lista}</div>
      )}
    </div>
  );
};

PassosView.propTypes = {
  data: PropTypes.shape({
    disposicao: PropTypes.string,
    fundo: PropTypes.string,
    passos: PropTypes.arrayOf(
      PropTypes.shape({
        titulo: PropTypes.string,
        texto: PropTypes.string,
        link: PropTypes.string,
        rotuloLink: PropTypes.string,
      }),
    ),
  }),
  vazio: PropTypes.node,
};

export default PassosView;
